import { CloudUpload, Download } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";

import { downloadTemplate } from "./utils";

interface FileSelectPhaseProps {
  onSelectFile: () => void;
  requireInternalUserId?: boolean;
}

export const FileSelectPhase = ({
  onSelectFile,
  requireInternalUserId = false,
}: FileSelectPhaseProps) => (
  <>
    <Button
      variant="outlined"
      startIcon={<Download />}
      onClick={() => downloadTemplate(requireInternalUserId)}
      sx={{ alignSelf: "flex-start" }}
    >
      Download Template
    </Button>

    <Box
      sx={{
        border: "2px dashed",
        borderColor: "grey.400",
        borderRadius: 1,
        p: 4,
        textAlign: "center",
        cursor: "pointer",
        "&:hover": { borderColor: "primary.main" },
      }}
      onClick={onSelectFile}
    >
      <CloudUpload sx={{ fontSize: 48, color: "grey.400", mb: 1 }} />
      <Typography variant="body1" color="text.secondary">
        Click to select a CSV file
      </Typography>
      <Typography variant="caption" color="text.disabled">
        {requireInternalUserId
          ? "Required columns: email, internal_user_id"
          : "Required column: email"}
      </Typography>
    </Box>
  </>
);
